import {
  UNAVAILABLE} from 'src/pages/scheduleCallback/constants/views';
import {
  intent,
} from 'src/pages/scheduleCallback/store/selectors/app';
import {fragment} from 'src/pages/scheduleCallback/utils';
import {changeView} from 'src/shared/currentView/actions';
import {logScreenName} from 'src/shared/dataLayer/loggers';
import {pushHistory} from 'src/shared/history/actions';

export const unavailableStep = () => (dispatch, getState) => {
  dispatch(changeView(UNAVAILABLE));
  dispatch(pushHistory(unavailableStep(), fragment('unavailable')));
  logScreenName(`unavailable|${intent(getState())}`);
};
